<template>
  <div>
    <div
      :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 shadow-table p-3 position-relative`"
    >
      <Loading v-if="loading" />
      <div class="row">
        <div class="col">
          <div class="form-floating text-dark my-3">
            <input
              v-model="form.name"
              type="text"
              class="form-control border-secondary"
              id="formName"
            />
            <label for="formName">Nombre</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("name") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <input
              v-model="form.nickname"
              type="text"
              class="form-control border-secondary"
              id="formName"
            />
            <label for="formName">Nick</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("nickname") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <input
              v-model="form.email"
              type="text"
              class="form-control border-secondary"
              id="formName"
            />
            <label for="formName">E-mail</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("email") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <v-select
              v-model="form.company_id"
              :reduce="(company) => company.id"
              class="form-select border-secondary"
              aria-label="Seleccionar Proyecto"
              :options="companiesList"
              label="name"
              :clearable="false"
            >
            </v-select>
            <label for="itemParent">Seleccionar Empresa</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("company_id") }}
            </p>
          </div>
          <div class="form-floating text-dark input-group my-3">
            <input
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              class="form-control"
              id="floatingPassword"
              placeholder="Contraseña"
              autocomplete="off"
              minlength="8"
            />
            <label for="floatingPassword">Contraseña</label>
            <button
              class="btn btn-light"
              type="button"
              @click="showPassword = !showPassword"
            >
              <font-awesome-icon
                :icon="['fal', showPassword ? 'eye-slash' : 'eye']"
              />
            </button>
          </div>
          <p class="missing-data-message" v-if="validateData()">
            {{ validateDataMessage("password") }}
          </p>
          <div class="form-floating text-dark input-group my-3">
            <input
              v-model="form.password_confirmation"
              :type="showConfirmPassword ? 'text' : 'password'"
              class="form-control"
              id="floatingPassword"
              placeholder="Repetir contraseña"
              autocomplete="off"
            />
            <label for="floatingPassword">Repetir contraseña</label>
            <button
              class="btn btn-light"
              type="button"
              @click="showConfirmPassword = !showConfirmPassword"
            >
              <font-awesome-icon
                :icon="['fal', showConfirmPassword ? 'eye-slash' : 'eye']"
              />
            </button>
          </div>
          <p class="missing-data-message" v-if="validateData()">
            {{ validateDataMessage("password_confirmation") }}
          </p>
          <div class="input-group mb-4">
            <Popper
              content="Le otorgará todos los permisos al usuario, pudiendo ver, editar, eliminar, y agregar en todos los proyectos"
              placement="top"
              hover
              arrow
              offsetDistance="35"
            >
              <font-awesome-icon
                :icon="['fal', 'question-circle']"
                class="mx-1"
              />
              <label for="formIsAdmin" :class="`text-${getColorMode.text}`">
                ¿Es Administrador?
                <input
                  type="checkbox"
                  id="formIsAdmin"
                  v-model="form.is_admin"
                />
              </label>
            </Popper>
          </div>
          <table
            :class="`table table-${getColorMode.background}`"
            v-if="!form.is_admin"
          >
            <thead v-if="menuSections">
              <tr>
                <th
                  v-for="(value, key) in menuSections.columns"
                  v-bind:key="`table-column-${key}`"
                >
                  {{ value.text }}
                </th>
              </tr>
            </thead>
            <tbody v-if="menuSections">
              <tr
                v-for="(row, keyRow) in menuSections.data"
                v-bind:key="`table-inner-row-${keyRow}`"
              >
                <td>
                  {{ row.name }}
                </td>
                <td>
                  <input
                    type="checkbox"
                    :value="row.id"
                    v-model="row.user_has_permission"
                    :checked="row.user_has_permission"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-end">
            <button
              type="button"
              @click="saveData()"
              class="btn btn-primary"
              :disabled="validateData()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import Loading from "@/components/Loading.vue";
export default {
  name: "user-form",
  emits: ["setBreadcrumb"],
  components: { Loading },
  props: {
    dataId: { default: null },
  },
  data() {
    return {
      breadcrumb: [{ text: "Usuarios", link: { name: "users" } }],
      form: {
        name: null,
        nickname: null,
        email: null,
        company_id: null,
        password: null,
        password_confirmation: null,
        is_admin: false,
      },
      companiesList: [],
      showPassword: false,
      showConfirmPassword: false,
      menuSections: [],
      selectedMenuSections: {},
    };
  },
  created() {
    this.setData();
    if (this.dataId) {
      this.breadcrumb.push({
        text: "Editar",
        link: { name: "edit-user-form" },
      });
    } else {
      this.breadcrumb.push({ text: "Crear", link: { name: "new-user-form" } });
    }
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  methods: {
    ...mapMutations("general", ["setMenuByUser"]),
    setData() {
      let app = this;
      if (this.dataId) {
        this.axios
          .get(`users/${this.dataId}`)
          .then((result) => {
            app.form = result.data.body;
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.axios
        .get(`companies/list`)
        .then((result) => {
          app.companiesList = result.data.body;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .get(`menu_sections?id=${this.dataId}`)
        .then((result) => {
          app.menuSections = result.data.body;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      let app = this;
      this.loading = true;
      app.menuSections.data.map(
        (menu_section) =>
          (app.selectedMenuSections[`${menu_section.id}`] =
            menu_section.user_has_permission)
      );
      if (this.dataId) {
        this.axios
          .put(`users/${this.dataId}`, {
            user: this.form,
            menu_sections: app.selectedMenuSections,
          })
          .then(() => {
            app.$router
              .push({
                name: "users",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
            app.loading = true;
            this.updateMenu(app.form.is_admin);
          })
          .catch((error) => {
            console.log(error);
            app.loading = true;
          });
      } else {
        this.axios
          .post("users", {
            user: this.form,
            menu_sections: app.selectedMenuSections,
          })
          .then(() => {
            app.$router
              .push({
                name: "users",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
            app.loading = true;
            this.updateMenu(app.form.is_admin);
          })
          .catch((error) => {
            console.log(error);
            app.loading = true;
          });
      }
    },
    updateMenu(is_admin) {
      if (this.dataId == this.$auth.$vm.state.data.id) {
        if (!is_admin) {
          this.axios
            .get(`menu_sections?id=${this.$auth.$vm.state.data.id}`)
            .then((result) => {
              let newMenu = result.data.body.data;
              let permittedMenuSections = [];
              newMenu.filter((menuSection) => {
                if (menuSection.user_has_permission == true) {
                  permittedMenuSections.push(menuSection.name);
                }
              });
              this.setMenuByUser(
                this.getOriginalMenu.filter((menuSection) => {
                  if (permittedMenuSections.includes(menuSection.name))
                    return menuSection;
                })
              );
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.setMenuByUser(this.getOriginalMenu);
        }
      }
    },
    validateData() {
      if (
        this.form.name &&
        this.form.nickname &&
        this.form.email &&
        this.form.company_id &&
        this.validateEmail(this.form.email)
      ) {
        if (this.form.password || this.form.password_confirmation) {
          if (
            this.form.password_confirmation &&
            this.form.password == this.form.password_confirmation &&
            this.form.password.length >= 8
          )
            return false;
        } else return false;
      }
      return true;
    },
    validateDataMessage(field) {
      switch (field) {
        case "name":
          if (!this.form.name) return "Debe ingresar un nombre";
          break;
        case "nickname":
          if (!this.form.nickname) return "Debe ingresar un apodo";
          break;
        case "email":
          if (!this.form.email) return "Debe ingresar un correo";
          else if (!this.validateEmail(this.form.email))
            return "Debe ingresar un correo valido";
          break;
        case "company_id":
          if (!this.form.company_id) return "Debe seleccionar una empresa";
          break;
        case "password":
          if (this.form.password && this.form.password.length < 8)
            return "Debe ingresar una contraseña que contenga al menos 8 caracteres";
          break;
        case "password_confirmation":
          if (
            (this.form.password && this.form.password_confirmation) ||
            (this.form.password && !this.form.password_confirmation) ||
            (!this.form.password && this.form.password_confirmation)
          )
            if (this.form.password_confirmation != this.form.password)
              return "Ambas contraseñas deben coincidir";
          break;
      }
    },
    validateEmail(email) {
      var validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (email.match(validRegex)) {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode", "getOriginalMenu"]),
    getFolderList() {
      return this.folderList;
    },
    getFolders() {
      return this.folders;
    },
  },
};
</script>
